import SettingsPayouts from './_Root';

const Campaigns = () => import( /* webpackChunkName: "settings" */ './Campaigns/_Root');
const CampaignsPending = () => import( /* webpackChunkName: "settings" */ './Campaigns/PendingTable');
const CampaignsAvailable = () => import( /* webpackChunkName: "settings" */ './Campaigns/AvailableTable');
const CampaignsRequested = () => import( /* webpackChunkName: "settings" */ './Campaigns/RequestedTable');
const Referrals = () => import( /* webpackChunkName: "settings" */ './Referrals/_Root');
const ReferralsCurrentCycle = () => import( /* webpackChunkName: "settings" */ './Referrals/CurrentCycleTable');
const ReferralsAvailable = () => import( /* webpackChunkName: "settings" */ './Referrals/AvailableTable');
const ReferralsRequested = () => import( /* webpackChunkName: "settings" */ './Referrals/RequestedTable');
const ReferralsPaid = () => import( /* webpackChunkName: "settings" */ './Referrals/PaidTable');
const Affiliate = () => import( /* webpackChunkName: "settings" */ './Affiliate/_Root');
const AffiliatePending = () => import( /* webpackChunkName: "settings" */ './Affiliate/PendingTable');
const AffiliateAvailable = () => import( /* webpackChunkName: "settings" */ './Affiliate/AvailableTable');
const AffiliateRequested = () => import( /* webpackChunkName: "settings" */ './Affiliate/RequestedTable');
const Deductions = () => import( /* webpackChunkName: "settings" */ './Deductions/Table');

export default {
  path: 'payouts',
  name: 'settingsPayouts',
  redirect: '/settings/payouts/campaigns',
  component: SettingsPayouts,
  children: [{
    path: 'campaigns',
    name: 'settingsPayoutsCampaigns',
    redirect: '/settings/payouts/campaigns/available',
    component: Campaigns,
    children: [{
      path: 'pending',
      name: 'settingsPayoutsCampaignsPending',
      component: CampaignsPending,
    }, {
      path: 'available',
      name: 'settingsPayoutsCampaignsAvailable',
      component: CampaignsAvailable,
    }, {
      path: 'requested',
      name: 'settingsPayoutsCampaignsRequested',
      component: CampaignsRequested,
    }],
  }, {
    path: 'referrals',
    name: 'settingsPayoutsReferrals',
    redirect: '/settings/payouts/referrals/currentcycle',
    component: Referrals,
    children: [{
      path: 'currentcycle',
      name: 'settingsPayoutsReferralsCurrentCycle',
      component: ReferralsCurrentCycle,
    }, {
      path: 'available',
      name: 'settingsPayoutsReferralsAvailable',
      component: ReferralsAvailable,
    }, {
      path: 'requested',
      name: 'settingsPayoutsReferralsRequested',
      component: ReferralsRequested,
    }, {
      path: 'paid',
      name: 'settingsPayoutsReferralsPaid',
      component: ReferralsPaid,
    }],
  }, {
    path: 'affiliate',
    name: 'settingsPayoutsAffiliate',
    redirect: '/settings/payouts/affiliate/available',
    component: Affiliate,
    children: [{
      path: 'pending',
      name: 'settingsPayoutsAffiliatePending',
      component: AffiliatePending,
    }, {
      path: 'available',
      name: 'settingsPayoutsAffiliateAvailable',
      component: AffiliateAvailable,
    }, {
      path: 'requested',
      name: 'settingsPayoutsAffiliateRequested',
      component: AffiliateRequested,
    }],
  }, {
    path: 'deductions',
    name: 'settingsPayoutsDeductions',
    component: Deductions,
  }],
};